import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaCardComponent } from '@global-front-components/ui/card';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DateUtilsService } from '../../services/util/date-utils.service';
import { ColumnasTabla } from '../../../ui/model/tabla-seguros.model';
import { forkJoin } from 'rxjs';
import { RegistroMensajeSGO } from './model/tabla-mensajes-sgo.model';
import { CdkTableModule } from '@angular/cdk/table';
import { CaTablaSegurosComponent } from '../../../ui/components/tabla-seguros/tabla-seguros.component';
import { Expediente, Suceso } from '../../model/solicitud.model';

@Component({
	selector: 'app-datos-solicitud-estados',
	standalone: true,
	imports: [
		CommonModule,
		CaCardComponent,
		TranslateModule,
		CaTablaSegurosComponent
	],
	templateUrl: './datos-solicitud-estados.component.html',
	styleUrls: ['./datos-solicitud-estados.component.scss']
})
export class DatosSolicitudEstadosComponent {
	@Input() mensajes: Expediente[];
	registros: RegistroMensajeSGO[];
	columnas: ColumnasTabla[] = [];

	constructor(
		private translateService: TranslateService,
		private dateUtil: DateUtilsService
	) { }

	ngOnInit(): void {
		this.getTraducciones();
		if (this.mensajes?.length) {
			this.registros = this.convertirSucesosTabla(this.mensajes)
		}
	}

	private getTraducciones(): void {
		forkJoin([
			this.translateService.get('DATOS_SOLICITUD.DATOS_SOLICITUD_ESTADOS.TABLA_MENSAJES.FECHA'),
			this.translateService.get('DATOS_SOLICITUD.DATOS_SOLICITUD_ESTADOS.TABLA_MENSAJES.ESTADO'),
			this.translateService.get('DATOS_SOLICITUD.DATOS_SOLICITUD_ESTADOS.TABLA_MENSAJES.MOTIVO'),
		]).subscribe(translations => {
			this.columnas = [
				{ id: 0, field: 'fecha', value: translations[0] },
				{ id: 1, field: 'estado', value: translations[1] },
				{ id: 2, field: 'motivo', value: translations[2] },
			];
		});
	}

	private convertirSucesosTabla(expedientes: Expediente[]): RegistroMensajeSGO[] {
		return expedientes
			.flatMap(expediente => expediente.sucesos || []) // Flatten all sucesos
			.map((suceso: Suceso) => ({
				fecha: this.dateUtil.formatearFecha(suceso.fecha),
				estado: suceso.estado ?? '',
				motivo: suceso.motivo ?? ''
			}));
	}

}
